export { default } from './MediaImageFluid';
